// extracted by mini-css-extract-plugin
module.exports = {"ModalBody":"ModalBody-1qaAR","Title":"Title-FMxoI","Paragraph":"Paragraph-uktve","Pink":"Pink-1nVVS"};